"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const floating_vue_1 = require("floating-vue");
let PhChInsightsComparison = class PhChInsightsComparison extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.clusters = ['', 'main', 'secondary'];
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get fixedCluster() {
        return this.clusters.findIndex((c) => c === this.higherIn);
    }
    get fixedClusterColor() {
        let cl = this.fixedCluster;
        if (cl === 2)
            return cl + '--tint-3';
        return cl;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], PhChInsightsComparison.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'The pH' })
], PhChInsightsComparison.prototype, "title", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'pH' })
], PhChInsightsComparison.prototype, "symbol", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '-' })
], PhChInsightsComparison.prototype, "area", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '0.5' })
], PhChInsightsComparison.prototype, "variation", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '8.0' })
], PhChInsightsComparison.prototype, "from", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '7.5' })
], PhChInsightsComparison.prototype, "to", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'secondary' })
], PhChInsightsComparison.prototype, "higherIn", void 0);
PhChInsightsComparison = __decorate([
    (0, vue_property_decorator_1.Options)({
        name: "PhChInsightsComparison",
        components: {
            Dropdown: floating_vue_1.Dropdown
        }
    })
], PhChInsightsComparison);
exports.default = PhChInsightsComparison;
